const serviceProviders = {
  serviceProviderList: 'مقدمي الخدمات',
  list: {
    search: 'ابحث عن مقدم خدمة',
    noDataSubTitle: 'لا يوجد مقدمي خدمات لعرضهم حتى الآن',
    noDataDescription: 'ابدأ الآن بإضافة مقدمي خدمات',
    CreateButton: 'إضافة مقدم خدمة جديد',
    category: 'الفئة',
    branches: 'الفروع',
    addBranch: 'اضافة فرع',
    generatePassword: 'انشاء كلمة مرور',
    editStatus: 'تعديل الحالة',
    filter: {
      filtersPlaceHolders: {
        filterByCategory: 'الفئة',
        filterByProviderStatus: 'الحالة',
      },
    },
    suspendedByBlock: 'سيتم حظر مقدم الخدمة بعد انتهاء جميع حجوزاته',
    suspendedByDeactivateProvider: 'سيتم ايقاف مقدم الخدمة بداية من',
    status: {
      active: 'نشط',
      deactivated: 'معطل',
      blocked: 'محظور',
      suspended: 'معلق',
      unpublished: 'غير منشور',
      requestedPublishing: 'طلب نشر',
    },
    statusActions: {
      activate: 'تنشيط',
      block: 'حظر',
      deactivateNow: 'تعطيل فورى',
      deacivateLater: 'تعطيل بداية من تاريخ محدد',
      deacivateLaterTitle: 'تعطيل مقدم الخدمة',
      dateLabel: 'بداية من',
    },
    blockProviderHint:'ستم تعليق ذلك مقدم الخدمة حتى يستكمل الحجوزات الجارية ثم يتم حظره تلقائيًا'
  },
  addServiceProvider: {
    title: 'أضف مقدم خدمة جديد',
    labels: {
      email: 'بريدك الإلكتروني',
      CommercialRegistrationNumber: 'رقم السجل التجاري / شهادة العمل الحر/ الاقامة',
      ExpiryDate: 'تاريخ انتهاء التسجيل التجاري',
      UploadCR: "رفع شهادة السجل التجاري / شهادة العمل الحر/ صورة الاقامة",
      acceptedFilesImgPdf:"الحجم الاقصى 5MB, الصيغات المقبولة pdf, png, jpg, jpeg",
      joiningDate:"تاريخ الانضمام",
      iban:"IBAN",
      contract:"تحميل العقد",
      enDescription:'وصف باللغة الإنجليزية',
      arDescription:'وصف باللغة العربية',
    },
    placeholders: {
      email: 'أدخل بريدك الإلكتروني',
      ArName: 'أدخل الاسم بالغة العربية',
      EnName: 'أدخل الاسم بالغة الانجليزية',
      category: 'اختر الفئة',
      uploadLogo: 'شعار',
      banner: 'الغلاف',
      mimarCommission: "ادخل عمولة ميمار",
      CommercialRegistrationNumber:"ادخل رقم السجل التجاري, رقم شهادة العمل الحر أو رقم الاقامة",
      ExpiryDate:"ادخل تاريخ الانتهاء",
      UploadCR:"أرفق شهادة السجل التجاري, شهادة العمل الحر, صورة الاقامة",
      commissionFixedFees:"ادخل رسوم ثابتة",
      mimarPercentage:"ادخل النسبة",
      enDescription:'صف عملك (أو نشاطك التجاري) باللغة الإنجليزية',
      arDescription:'صف عملك (أو نشاطك التجاري) باللغة العربية',
    },
    mimarCommissionOptions:{
      percentage:"نسبة",
      fixed_fees:"رسوم ثابتة"
    }
  },
  editServiceProvider: {
    title: 'تعديل مقدم الخدمة',
    confirmChangeCommissionTitle: "تغيير عمولة ميمار",
    confirmChangeFixedFeesCommissionMessage: "عمولة ميمار الثابتة لن تؤثر على إعدادات الشهر الحالي وسيتأثر فقط من الشهر التالي",
    confirmChangePercentageCommissionMessage: "عمولة ميمار النسبة لن تؤثر على إعدادات الشهر الحالي وسيتأثر فقط من الشهر التالي",
    confirmChangePercentageCommissionValueMessage: "سيتم تطبيق العمولة الجديدة على المدفوعات القادمة",
  },
  deleteServiceProvider: {
    title: 'حذف مقدم الخدمة',
    deleteConfirmationMsg: 'هل أنت متأكد من حذف مقدم الخدمة ؟ ',
  },
  viewServiceProvider: {
    title: 'تفاصيل مقدم الخدمة',
    noProvider: 'لم تتم إضافة أي مقدمين خدمة حتى الآن.',
    showPasswordTitle: 'تفاصيل كلمة المرور',
    passwordIs: 'كلمة مرور مقدم الخدمة هي: ',
    generatePassword: 'انشاء كلمة مرور',
    noBranches: 'لم يتم إضافة فروع بعد',
    commissionType: 'نوع العمولة',
    comissionValue: 'قيمة العمولة',
    joiningDate: 'تاريخ الانضمام',
    contract: 'عقد',
    verificationDocument: 'مستند التوثيق',
    verificationDocumentTooltip: 'شهادة السجل التجاري / شهادة العمل الحر/ صورة الاقامة',
    documentNumber: 'رقم المستند',
    documentExpiry: 'تاريخ إنتهاء المستند',
    iban: 'IBAN رقم ال',
    SR: 'ريال سعودي',
    perTransaction: 'لكل معاملة',
    billedMonthly: 'تدفع شهريًا',
  },
  CommissionTooltip: 'لاحظ أن هذه العمولة تطبق فقط على ذلك مقدم الخدمة'

};

export default serviceProviders;
